import {
  BenefitDocumentDto,
  BenefitDocument,
  BenefitRootDocumentDto,
  BenefitDocumentsDataDto,
  BenefitDocumentsData,
} from '../types';
import { ALLOWED_BENEFIT_DOCUMENT_TYPE_EXTENSIONS } from '.';

export const mapBenefitDocuments = (
  benefitDocuments: BenefitDocumentsDataDto
): BenefitDocumentsData => ({
  documentsUrl: benefitDocuments.documents_url,
  trees: benefitDocuments.trees.map((document) => ({
    ...mapSharedDocumentData(document),
    archiveUrl: document.archive_url,
    fileUrl: document.file_url,
    orgPlanYearId: document.org_plan_year_id,
    updatedAt: document.updated_at,
    children: filterBenefitDocumentTypes(
      mapBenefitDocumentChildren(document.children)
    ),
  })),
});

const filterBenefitDocumentTypes = (
  benefitDocuments: BenefitDocument[]
): BenefitDocument[] =>
  benefitDocuments.filter((document) =>
    !document.folder
      ? ALLOWED_BENEFIT_DOCUMENT_TYPE_EXTENSIONS.some((fileType) => {
          const fileName = document.fileUrl.toLowerCase().split('&')[0];
          return fileName.endsWith(fileType);
        })
      : document.children &&
        document.children.map((document) =>
          ALLOWED_BENEFIT_DOCUMENT_TYPE_EXTENSIONS.some((fileType) => {
            const fileName =
              document.fileUrl && document.fileUrl.toLowerCase().split('&')[0];
            return fileName && fileName.endsWith(fileType);
          })
        )
  );

export const filterDocuments = (
  benefits: BenefitDocument[],
  filter: string
): BenefitDocument[] =>
  benefits.filter(
    (file) =>
      filter === '' || file.title.toLowerCase().includes(filter.toLowerCase())
  );

function mapBenefitDocumentChildren(
  children: BenefitDocumentDto[]
): BenefitDocument[] {
  const flatChildren: BenefitDocument[] = [];
  children.forEach((document) => {
    flatChildren.push({
      ...mapSharedDocumentData(document),
      children: mapBenefitDocumentChildren(document.children),
      orgPopulationIds: document.org_population_ids,
      fileUrl: document.file_url,
      orgPlanYearId: document.org_plan_year_id,
      updatedAt: document.updated_at,
    });
  });
  return flatChildren;
}

function mapSharedDocumentData(
  document: BenefitRootDocumentDto | BenefitDocumentDto
) {
  return {
    key: document.key,
    status: document.status,
    title: document.title,
    folder: document.folder,
    type: document.type,
    url: document.url,
  };
}
